import React from 'react';
import { SliderSC } from './slider.styled';

const Slider = ({ value, min, max, step, ishandle, className, onChange }) => {
  return (
    <SliderSC
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={onChange}
      ishandle={ishandle}
      thumbClassName={`sl-handle ${className ? className : ''}`}
      renderThumb={(props) => <div {...props}></div>}
    />
  );
};

export default Slider;
